import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-white" data-id="element-130">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gray-900 rounded-3xl p-8 md:p-12 text-center text-white relative overflow-hidden" data-id="element-132">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/20 via-gray-900 to-gray-900 pointer-events-none" data-id="element-133" />

          <div className="relative z-10" data-id="element-134">
            <ShieldCheck className="w-16 h-16 text-green-400 mx-auto mb-6" data-id="element-135" />
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-136">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <div className="space-y-2 text-lg text-gray-300 mb-8" data-id="element-137">
              <p data-id="element-138">Abrís los tomos. Los usás en tu negocio.</p>
              <p data-id="element-139">
                Si en 7 días no es lo que esperabas:{' '}
                <span className="font-bold text-white text-xl" data-id="element-140">
                  devolución del 100%
                </span>
                , sin formularios, sin drama.
              </p>
            </div>
            <div className="inline-block bg-white/10 px-4 py-2 rounded-full text-sm font-medium text-gray-300" data-id="element-141">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}